import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import * as appActions from '../actions/app.actions';
import * as userProfileActions from '../actions/user-profile.actions';
import { LoggerService } from '../services/logger.service';

import 'rxjs/add/operator/mergeMap';

/**
 * Effects handle initial fetch requests:
 * - user profile retrieval
 * - contracts retrieval
 * - and consent retrieval
 */
@Injectable()
export class AppEffects {

    @Effect() appEffects$ = this.actions$
        .ofType(appActions.READY)
        .do(() => this.logger.log('APP READY'))
        .mergeMap(() => [
            new userProfileActions.LoadRequestAction(),
        ]);

    constructor(private actions$: Actions, private logger: LoggerService) {}

}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/angular-router-loader/src!./~/tslint-loader!./src/app/core/effects/app.effects.ts